import React from "react";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";

// react component used to create a calendar with events on it
import BigCalendar from "react-big-calendar";
// dependency plugin for react-big-calendar
import moment from "moment";
// react component used to create alerts
import SweetAlert from "react-bootstrap-sweetalert";

import { getReceiverShipments } from '../../actions/shipment'

// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import RegularCard from "components/Cards/RegularCard.jsx";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class Calendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [],
      alert: null
    };
    this.hideAlert = this.hideAlert.bind(this);
  }
  selectedEvent(event) {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={event.title}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        >
          <table >
              <tbody>
          {Object.keys(event.data).map((prop, key)=>{
            return (
                <tr key={key}><th>{prop}</th><td>{event.data[prop]}</td></tr>
              );
          })}
              </tbody>
          </table>
        </SweetAlert>

      )
    });
      console.log(event);
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }
  eventColors(event, start, end, isSelected) {
    var backgroundColor = "event-";
    event.color
      ? (backgroundColor = backgroundColor + event.color)
      : (backgroundColor = backgroundColor + "default");
    return {
      className: backgroundColor
    };
  }

  componentDidMount() {
    this.props.dispatchGetReceiverShipments(this.props.auth.user)
    .then( shipments => {

      let events = shipments.map((prop,key)=>{
        return {
          title: prop.shipmentCarrier+" for "+prop.customer,
          allDay: true,
          start: new Date(prop.shipmentDateRangeStart),
          end: new Date(prop.shipmentDateRangeEnd),
          color: "default",
          data: prop,
        };
      });
      this.setState({events});
    });   
  }

  render() {
    return (
      <div>
        {this.state.alert}
        <GridContainer justify="center">
          <ItemGrid xs={12} sm={12} md={10}>
            <RegularCard
              content={
                <BigCalendar
                  selectable
                  events={this.state.events}
                  defaultView="month"
                  scrollToTime={new Date(1970, 1, 1, 6)}
                  defaultDate={new Date()}
                  onSelectEvent={event => this.selectedEvent(event)}
                  eventPropGetter={this.eventColors}
                />
              }
            />
          </ItemGrid>
        </GridContainer>
      </div>
    );
  }
}

const mapDispatchToProps = {
  dispatchGetReceiverShipments: (user) => getReceiverShipments(user),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
  }
}


export default compose(
  withStyles(sweetAlertStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(Calendar);



// WEBPACK FOOTER //
// ./src/views/Receiver/Calendar.jsx